import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import Fab from "@material-ui/core/Fab";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    position: 'fixed',
    bottom: '6%',
    right: '3%'
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
});

function FloatingActionButton(props) {
  const { classes, onClick } = props;
  return (
    <Fab  color="primary" aria-label="Add" className={classes.button} onClick={onClick}>
      <AddIcon />
    </Fab >
  );
}

FloatingActionButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

export default withStyles(styles)(FloatingActionButton);



// WEBPACK FOOTER //
// ./src/components/elements/floatingActionButton.js